import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import type { JourneyResultProp } from '../types';
import { getError } from '../utils';

import styles from './Error.scss';

const Error: React.FC<JourneyResultProp> = ({ journeyResult }) => {
  const errorMessage = getError(journeyResult);

  return errorMessage ? (
    <StarsInfo className={styles.error} type="error">
      {errorMessage}
    </StarsInfo>
  ) : null;
};

export default Error;
